@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

@if(debtor){
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>{{debtor.Name}}</mat-card-title>
            <mat-card-subtitle>{{debtor.Nummer}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content> 
            <mat-list>
                @if(debtor.Strasse){ <mat-list-item><span style="font-weight: bold">{{language.Strasse | translationPipe}}: </span><span>{{debtor.Strasse}}</span> </mat-list-item>} 
                @if(debtor.PLZ || debtor.Ort){ <mat-list-item><span style="font-weight: bold">{{language.PLZ | translationPipe}}/{{language.Ort  | translationPipe}}: </span><span>{{debtor.PLZ}} {{debtor.Ort}}</span></mat-list-item>}                 
            </mat-list>
        </mat-card-content>
    </mat-card>
}
<mat-accordion>

        @for(standort of standortList; track standort.StandortID){
            <mat-expansion-panel class="roofPanel">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{language.Standort | translationPipe}}: {{standort.Bezeichnung}}</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list>
                    @if(standort.Strasse){ <mat-list-item><span style="font-weight: bold">{{language.Strasse | translationPipe}}: </span><span>{{standort.Strasse}}</span> </mat-list-item>} 
                    @if(standort.PLZ || standort.Ort){ <mat-list-item><span style="font-weight: bold">{{language.PLZ | translationPipe}}/{{language.Ort  | translationPipe}}: </span><span>{{standort.PLZ}} {{standort.Ort}}</span></mat-list-item>}                     
                </mat-list>
                @for(objekt of this.getObjektList(standort.StandortID) ; track objekt.ObjektID){
                <mat-card appearance="outlined" [routerLink]="'/object/' + objekt.ObjektID">
                    <mat-card-header>
                        <mat-card-title>{{language.objekt | translationPipe}}: {{objekt.Bezeichnung}}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <mat-list>
                            @if(objekt.Strasse){ <mat-list-item><span style="font-weight: bold">{{language.Strasse | translationPipe}}: </span><span>{{objekt.Strasse}}</span> </mat-list-item>} 
                            @if(objekt.PLZ || objekt.Ort){ <mat-list-item><span style="font-weight: bold">{{language.PLZ | translationPipe}}/{{language.Ort  | translationPipe}}: </span><span>{{objekt.PLZ}} {{objekt.Ort}}</span></mat-list-item>} 
                        </mat-list>
                    </mat-card-content>
                </mat-card>
                }

            </mat-expansion-panel>   
        }

            <button mat-fab (click)="openObjektDialog(debtor)">
                <mat-icon>add</mat-icon>
            </button>            

    </mat-accordion>